import { common } from '@neo-one/client-common';
import { Hash160ContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
export class StorageContextStackItem extends StackItemBase {
    constructor(value, isReadOnly = false) {
        super();
        this.value = value;
        this.isReadOnly = isReadOnly;
    }
    asUInt160() {
        return this.value;
    }
    asBoolean() {
        return this.value !== undefined;
    }
    asBuffer() {
        return common.uInt160ToBuffer(this.value);
    }
    asStorageContextStackItem(_options) {
        return this;
    }
    asReadOnly() {
        return new StorageContextStackItem(this.value, true);
    }
    toContractParameter(_seen = new Set()) {
        return new Hash160ContractParameter(this.value);
    }
}

//# sourceMappingURL=StorageContextStackItem.js.map
